class PencilBar extends HTMLElement {
  constructor() {
    super();

    this.closeBtn = this.querySelector("[data-close]");

    this.closeBtn.addEventListener("click", () => {
      this.style.display = "none";

      const hidePencilBar = new CustomEvent("pencilbar:hide");
      document.dispatchEvent(hidePencilBar);
    });
  }
}

if (!customElements.get("pencil-bar")) {
  customElements.define("pencil-bar", PencilBar);
}
